import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { OfflineBanner } from './components/pwa/OfflineBanner'
import { UpdatePrompt } from './components/pwa/UpdatePrompt'
import { initTheme } from './lib/theme'
// i18n bootstrap (issue #472): initializes i18next, resolves the active locale,
// and syncs <html lang>. Side-effect import — must run before the app renders.
import './i18n'
import './index.css'

// index.html stamps the initial theme pre-paint; this wires OS-preference and
// cross-tab changes (issue #304).
initTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <OfflineBanner />
    <App />
    <UpdatePrompt />
  </StrictMode>,
)
